import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { SpaceService } from './../../../services/space.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';

import { AuthService } from './../../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-delete-image-confirm',
  templateUrl: './delete-image-confirm.component.html',
  styleUrls: ['./delete-image-confirm.component.scss']
})
export class DeleteImageConfirmComponent implements OnInit, OnChanges {
  @Input() selectedData;
  @Input() spaceData;
  deleteError;
  deleteSuccess;
  @Output() modalCloseEmit = new EventEmitter();
  isSubmitted = false;
  accessToken: any;
  constructor(
    public spaceService: SpaceService,
    public memberService: MemberService,
    private authService: AuthService,
    public helperService: HelperService,
    public router: Router
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.resetErrorValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedData && changes.selectedData.currentValue) {
      this.resetErrorValues();
    }
  }

  deleteData() {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;

    this.deleteError = undefined;
    this.deleteSuccess = undefined;
    let i;
    const mediaId = [];
    for (i = 0; i < this.selectedData.length; i++) {
      mediaId.push(this.selectedData[i].uuid);
    }

    const data = {
      media: mediaId
    };

    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.deleteMultipleImage({
      Authorization: this.accessToken,
      id: this.spaceData.uuid,
      body: formData
    }).subscribe((response: any) => {
      if (this.spaceData.space_type === 'video') {
        this.deleteSuccess = 'Video was deleted successfully.';
      } else {
        this.deleteSuccess = 'Image was deleted successfully.';
      }
      setTimeout(() => {
        this.modalCloseEmit.emit(true);
      }, 2000);
    }, err => {
      this.isSubmitted = false;
      if (err.error && err.error.error) {
        this.deleteError = err.error.error;
      } else {

        if (this.spaceData.space_type === 'video') {
          this.deleteError = 'There was error while deleting video.';
        } else {
          this.deleteError = 'There was error while deleting image.';
        }
      }
    });
  }

  closeModal() {
    this.modalCloseEmit.emit(undefined);
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteSuccess = undefined;
    this.deleteError = undefined;
  }
}
